module.exports = __webpack_public_path__ + "img/company_logo.89aaf9dd.svg";